import { getDispatcher } from '@soluto-private/mx-analytics';

export const dispatchAnalytics = (
    eventName: string,
    extraData?: Record<string, unknown>
): void => {
    const _dispatcher = getDispatcher({ path: '/', packageName: 'partner' });
    _dispatcher.dispatch(eventName, { ExtraData: { ...extraData } });
};
